export default __webpack_public_path__ + "static/media/doctor.7c2bc96d.png";